export const getBuildType = () => {
  const isChina = process.env.CLIENT === 'CHINA';
  return {
    isChina
  };
};
